import { render } from "./B2bFiltersCierresContables.vue?vue&type=template&id=3e5b8c38&scoped=true&lang=pug"
import script from "./B2bFiltersCierresContables.vue?vue&type=script&lang=js"
export * from "./B2bFiltersCierresContables.vue?vue&type=script&lang=js"

import "./B2bFiltersCierresContables.vue?vue&type=style&index=0&id=3e5b8c38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5b8c38"]])

export default __exports__